var s = "smartystreets-javascript-sdk",
  e = "6.3.0",
  t = "Quick and easy Smarty address validation.",
  i = ["smarty", "smartystreets", "address", "validation", "verification", "verify", "validate", "street-address", "geocoding", "addresses", "zipcode", "autocomplete", "autosuggest", "suggestions", "international", "http", "sdk"],
  r = ["dist", "README.md", "LICENSE"],
  a = "dist/cjs/index.cjs",
  o = "dist/esm/index.mjs",
  d = {
    ".": {
      import: "./dist/esm/index.mjs",
      default: "./dist/cjs/index.cjs"
    }
  },
  l = {
    build: "rollup --config",
    test: "mocha 'tests/**/*.{mjs,js}'"
  },
  n = "Smarty SDK Team <support@smarty.com> (https://www.smarty.com)",
  p = "Apache-2.0",
  m = {
    type: "git",
    url: "github:smartystreets/smartystreets-javascript-sdk"
  },
  u = {
    "@babel/preset-env": "^7.25.8",
    "@rollup/plugin-commonjs": "^28.0.1",
    "@rollup/plugin-json": "^6.1.0",
    "@rollup/plugin-node-resolve": "^15.3.0",
    "@rollup/plugin-terser": "^0.4.4",
    chai: "^4.3.6",
    mocha: "^10.2.0",
    rollup: "^4.22.5",
    "rollup-plugin-delete": "^2.1.0"
  },
  c = {
    axios: "^1.7.7",
    "axios-retry": "^4.5.0"
  },
  y = {
    name: s,
    version: e,
    description: t,
    keywords: i,
    files: r,
    main: a,
    module: o,
    exports: d,
    scripts: l,
    author: n,
    license: p,
    repository: m,
    devDependencies: u,
    dependencies: c
  };
export { n as author, y as default, c as dependencies, t as description, u as devDependencies, d as exports, r as files, i as keywords, p as license, a as main, o as module, s as name, m as repository, l as scripts, e as version };